import SafeHtml from "./SafeHtml";

export const COVER_ACCENTS = {
  emerald: { text: "text-emerald-600", bg: "bg-emerald-600", hover: "hover:bg-emerald-700", dot: "bg-emerald-500" },
  amber: { text: "text-amber-600", bg: "bg-amber-600", hover: "hover:bg-amber-700", dot: "bg-amber-500" },
  slate: { text: "text-slate-600", bg: "bg-slate-800", hover: "hover:bg-slate-900", dot: "bg-slate-500" },
  sky: { text: "text-sky-600", bg: "bg-sky-600", hover: "hover:bg-sky-700", dot: "bg-sky-500" },
  rose: { text: "text-rose-600", bg: "bg-rose-600", hover: "hover:bg-rose-700", dot: "bg-rose-500" },
};

const GBE_LOGO =
  "https://customer-assets.emergentagent.com/job_aroflo-hub/artifacts/0o4hadpf_gbe-logo-with-yellow-strip.jpg";

/** The centered content block — reused by the live preview and the full-screen gate. */
export function CoverSplashContent({ content }) {
  const accent = COVER_ACCENTS[content?.accent] || COVER_ACCENTS.emerald;
  const hero = content?.hero_image;
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-6 py-12 text-center" data-testid="cover-splash-content">
      {hero ? (
        <img src={hero} alt="" className="mb-8 h-28 w-28 rounded-md object-contain" data-testid="cover-hero-image" />
      ) : (
        <img src={GBE_LOGO} alt="GBE Group" className="mb-8 h-20 w-20 rounded-md object-cover" />
      )}
      {content?.eyebrow ? (
        <p className={`mb-3 text-xs font-bold uppercase tracking-[0.2em] ${accent.text}`} data-testid="cover-eyebrow">
          {content.eyebrow}
        </p>
      ) : null}
      <h1 className="font-heading text-3xl font-black tracking-tighter text-[#0A0A0A] sm:text-4xl" data-testid="cover-title">
        {content?.title || ""}
      </h1>
      {content?.body ? (
        <SafeHtml
          html={content.body}
          className="cover-body mt-5 space-y-3 text-base leading-relaxed text-neutral-600"
          data-testid="cover-body"
        />
      ) : null}
      {content?.button_label ? (
        <a
          href={content.button_url || "#"}
          data-testid="cover-button"
          className={`mt-8 inline-flex items-center rounded-sm px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 ${accent.bg} ${accent.hover}`}
        >
          {content.button_label}
        </a>
      ) : null}
    </div>
  );
}

/** Full-screen visitor-facing splash used to block the site. */
export default function CoverSplash({ content }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F9FAFB]" data-testid="cover-splash">
      <div className="w-full">
        <CoverSplashContent content={content} />
        <div className="mt-2 text-center">
          <a href="/login" className="text-xs font-medium text-neutral-400 underline-offset-2 hover:text-neutral-600 hover:underline" data-testid="cover-admin-login">
            Admin sign in
          </a>
        </div>
      </div>
    </div>
  );
}
